/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import { supabase } from '../supabaseClient';
   
function getEmmaReply(msg, listing) {
  const m = msg.toLowerCase();  
  const l = listing || {};
  const amenities = l.amenities || [];
  const titleText = (l.title || '').toLowerCase();
  const hasPool = amenities.some(a => a.toLowerCase().includes('piscine')) || titleText.includes('piscine');
  const hasParking = amenities.some(a => a.toLowerCase().includes('parking'));
  const hasClim = amenities.some(a => a.toLowerCase().includes('climatisation') || a.toLowerCase().includes('clim'));
  const hasWifi = amenities.some(a => a.toLowerCase().includes('wifi') || a.toLowerCase().includes('internet') || a.toLowerCase().includes('fibre')) || titleText.includes('wifi') || titleText.includes('fibre');
  const hasWash = amenities.some(a => a.toLowerCase().includes('lave-linge') || a.toLowerCase().includes('machine'));
  const hasSeaView = amenities.some(a => a.toLowerCase().includes('vue mer') || a.toLowerCase().includes('mer'));
  const hasGarden = amenities.some(a => a.toLowerCase().includes('jardin') || a.toLowerCase().includes('terrasse'));
  const hasBbq = amenities.some(a => a.toLowerCase().includes('barbecue') || a.toLowerCase().includes('bbq'));
  const price = l.price || l.priceNight || '—';
  const guests = l.guests || '—';
  const beds = l.beds || '—';
  const baths = l.baths || '—';
  const location = l.location || l.city || 'ce logement';
  

  const en = m.includes('english') || m.includes('speak') || m.includes('pool') || m.includes('parking') || m.includes('wifi') || m.includes('book') || m.includes('cancel') || m.includes('hello') || m.includes('how') || m.includes('what') || m.includes('is there') || m.includes('available') || m.includes('check') || m.includes('arrival') || m.includes('departure') || m.includes('pet') || m.includes('dog') || m.includes('cat') || m.includes('baby') || m.includes('kitchen') || m.includes('garden') || m.includes('bbq') || m.includes('barbecue') || m.includes('price') || m.includes('cost');
  const es = m.includes('español') || m.includes('hablas') || m.includes('hola') || m.includes('piscina') || m.includes('reservar') || m.includes('hay') || m.includes('tiene');
  const de = m.includes('deutsch') || m.includes('sprechen') || m.includes('hallo') || m.includes('gibt es');

  if (en) {
    if (m.includes('speak') || m.includes('english') || m.includes('language')) return 'Yes! I speak French, English, Spanish and German 🌍 How can I help you?';
    if (m.includes('pool') || m.includes('swimming')) return hasPool ? "Yes! This property has a private pool 🏊 Heated from May to October." : "This property doesn't list a pool. Contact the host to confirm.";
    if (m.includes('parking') || m.includes('car') || m.includes('garage')) return hasParking ? 'Yes, private parking is included — free of charge.' : "This property doesn't include private parking. Ask the host.";
    if (m.includes('wifi') || m.includes('internet')) return hasWifi ? 'Yes, high-speed WiFi is included.' : "WiFi isn't specified. Contact the host to confirm.";
    if (m.includes('check-in') || m.includes('arrival') || m.includes('key') || m.includes('access')) return 'Access codes are sent automatically 48h before check-in. Standard check-in from 3pm.';
    if (m.includes('check-out') || m.includes('departure')) return 'Standard check-out at 11am. Late check-out may be available — ask the host.';
    if (m.includes('cancel') || m.includes('refund')) return 'Free cancellation up to 7 days before arrival — full refund within 48h.';
    if (m.includes('price') || m.includes('cost') || m.includes('how much')) return `This property is ${price}€ per night, final price including all taxes.`;
    if (m.includes('guest') || m.includes('people') || m.includes('capacity')) return `This property accommodates up to ${guests} guests, with ${beds} bedroom(s) and ${baths} bathroom(s).`;
    return `I'm Emma, assistant for this property at ${location}. I speak French, English, Spanish and German 🌍 How can I help?`;
  }
  if (es) {
    if (m.includes('piscina')) return hasPool ? '¡Sí! Este alojamiento tiene piscina privada 🏊' : 'Este alojamiento no tiene piscina.';
    return `Soy Emma, asistente para este alojamiento en ${location}. ¡Hablo francés, inglés, español y alemán! 🌍`;
  }
  if (de) {
    if (m.includes('pool') || m.includes('schwimmbad')) return hasPool ? 'Ja! Diese Unterkunft hat einen privaten Pool 🏊' : 'Diese Unterkunft hat keinen Pool.';
    return `Ich bin Emma, Assistentin für diese Unterkunft in ${location}. Ich spreche Französisch, Englisch, Spanisch und Deutsch! 🌍`;
  }

  if (m.includes('piscine') || m.includes('baignade')) return hasPool ? "Oui ! Ce logement dispose d'une piscine privée 🏊 Chauffée à 28°C de mai à octobre." : "Ce logement ne dispose pas de piscine.";
  if (m.includes('parking') || m.includes('voiture') || m.includes('garage')) return hasParking ? 'Oui, le parking privé est inclus et gratuit.' : "Le parking privé n'est pas mentionné. Contactez l'hôte.";
  if (m.includes('wifi') || m.includes('internet') || m.includes('fibre')) return hasWifi ? 'Oui, le WiFi est inclus et disponible partout.' : "Le WiFi n'est pas précisé. Contactez l'hôte.";
  if (m.includes('clim') || m.includes('climatisation')) return hasClim ? 'Oui, la climatisation est disponible.' : "La climatisation n'est pas listée. Contactez l'hôte.";
  if (m.includes('lave-linge') || m.includes('machine à laver')) return hasWash ? 'Oui, un lave-linge est disponible.' : "Le lave-linge n'est pas précisé.";
  if (m.includes('barbecue') || m.includes('bbq')) return hasBbq ? 'Oui ! Un barbecue est disponible dans le jardin.' : "Le barbecue n'est pas listé.";
  if (m.includes('jardin') || m.includes('terrasse')) return hasGarden ? "Oui ! Le logement dispose d'une terrasse et d'un jardin privatif." : "Les espaces extérieurs ne sont pas précisés.";
  if (m.includes('prix') || m.includes('tarif')) return `Le logement est à ${price}€ par nuit, prix final toutes taxes incluses.`;
  if (m.includes('réserv') || m.includes('comment réserver')) return "Pour réserver : 1) Sélectionnez vos dates 2) \"Envoyer ma demande\" 3) L'hôte confirme sous 24h 4) Carte débitée seulement après confirmation.";
  if (m.includes('annul') || m.includes('rembours')) return "Annulation gratuite jusqu'à 7 jours avant — remboursement intégral sous 48h.";
  if (m.includes('check-in') || m.includes('checkin') || m.includes('arrivée') || m.includes('clé')) return "Les codes d'accès sont envoyés automatiquement 48h avant votre arrivée. Check-in standard à partir de 15h.";
  if (m.includes('check-out') || m.includes('checkout') || m.includes('départ')) return "Check-out standard à 11h. Late check-out possible — demandez à l'hôte 24h avant.";
  if (m.includes('restaurant') || m.includes('manger') || m.includes('que faire') || m.includes('activité')) return "L'hôte a rédigé un guide local complet — consultez la section \"Bons plans\" dans cette annonce !";
  if (m.includes('bonjour') || m.includes('bonsoir') || m.includes('salut') || m.includes('coucou')) return `Bonjour ! Je suis Emma, l'assistante pour ce logement à ${location} 😊 Comment puis-je vous aider ?`;
  return "Je transmets votre question à l'hôte qui vous répondra dans les 30 minutes.";
}

const WifiIcon   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M5 12.55a11 11 0 0114.08 0"/><path d="M1.42 9a16 16 0 0121.16 0"/><path d="M8.53 16.11a6 6 0 016.95 0"/><circle cx="12" cy="20" r="1"/></svg>;
const PoolIcon   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 16c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/><path d="M2 20c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/><circle cx="12" cy="6" r="2"/><path d="M12 8v5"/></svg>;
const CarIcon    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M5 17H3a2 2 0 01-2-2V9a2 2 0 012-2h14l4 4v4a2 2 0 01-2 2h-2"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>;
const SnowIcon   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><line x1="12" y1="2" x2="12" y2="22"/><path d="M17 7l-5 5-5-5"/><path d="M17 17l-5-5-5 5"/><line x1="2" y1="12" x2="22" y2="12"/></svg>;
const CoffeeIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M18 8h1a4 4 0 010 8h-1"/><path d="M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>;
const WashIcon   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="2" width="20" height="20" rx="2"/><circle cx="12" cy="13" r="4"/><circle cx="7" cy="7" r="1"/></svg>;
const SeaIcon    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 18c3-6 15-6 18 0"/><circle cx="12" cy="8" r="3"/></svg>;
const GardenIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2a10 10 0 100 20A10 10 0 0012 2z"/><path d="M12 2v20M2 12h20"/></svg>;
const ForkIcon   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 002-2V2"/><path d="M7 2v20"/><path d="M21 15V2v0a5 5 0 00-5 5v6c0 1.1.9 2 2 2h3zm0 0v7"/></svg>;
const BeachIcon  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 18c3-6 15-6 18 0"/><circle cx="12" cy="8" r="3"/><path d="M12 5V3"/></svg>;
const StarIconSm = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const BusIcon    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>;

function getAmenityIcon(label) {
  const l = label.toLowerCase();
  if (l.includes('piscine'))                                       return PoolIcon;
  if (l.includes('parking'))                                       return CarIcon;
  if (l.includes('clim'))                                          return SnowIcon;
  if (l.includes('wifi') || l.includes('fibre') || l.includes('internet')) return WifiIcon;
  if (l.includes('cuisine'))                                       return CoffeeIcon;
  if (l.includes('lave') || l.includes('machine'))                 return WashIcon;
  if (l.includes('jardin') || l.includes('terrasse'))              return GardenIcon;
  if (l.includes('mer') || l.includes('vue'))                      return SeaIcon;
  return WifiIcon;
}

function getType(title) {
  const t = (title || '').toLowerCase();
  if (t.includes('chalet'))                                              return 'chalet';
  if (t.includes('mas') || t.includes('bastide') || t.includes('domaine')) return 'mas';
  if (t.includes('appartement') || t.includes('studio'))                return 'appartement';
  if (t.includes('bergerie'))                                            return 'bergerie';
  return 'villa';
}

function calcTransparencyScore(listing) {
  let score = 0;
  if (listing.photos?.length >= 5)      score += 25;
  if (listing.description?.length >= 100) score += 20;
  if (listing.amenities?.length >= 5)   score += 15;
  if (listing.registration_number)      score += 20;
  if (listing.rules?.length >= 50)      score += 10;
  if (listing.price_deposit > 0)        score += 10;
  return score;
}

function calcNextAvailable(bookedRanges) {
  const today = new Date(); today.setHours(12, 0, 0, 0);
  const sorted = [...bookedRanges].sort((a, b) => a.date_start.localeCompare(b.date_start));
  let next = new Date(today);
  next.setDate(next.getDate() + 1);
  let changed = true;
  while (changed) {
    changed = false;
    for (const r of sorted) {
      const start = new Date(r.date_start + 'T12:00:00');
      const end   = new Date(r.date_end   + 'T12:00:00');
      if (next >= start && next < end) {
        next = new Date(end);
        next.setDate(next.getDate() + 1);
        changed = true;
      }
    }
  }
  return next;
}

// ── Composant menu de partage ────────────────────────────────────────────────
function ShareMenu({ title, url, onClose }) {
  const menuRef = useRef(null);
  const [copied, setCopied] = useState(false);

  // Fermer en cliquant dehors
  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  const encodedUrl   = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const options = [
    {
      label: 'WhatsApp',
      color: '#25D366',
      bg:    '#E8FAF0',
      href:  `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#25D366">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      ),
    },
    {
      label: copied ? '✓ Lien copié !' : 'Copier le lien',
      color: copied ? '#0F6E56' : '#374151',
      bg:    copied ? '#E8F5F0' : '#F3F4F6',
      action: 'copy',
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={copied ? '#0F6E56' : '#374151'} strokeWidth="1.8">
          {copied
            ? <polyline points="20 6 9 17 4 12"/>
            : <><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></>
          }
        </svg>
      ),
    },
  ];

  const handleClick = async (opt) => {
    if (opt.action === 'copy' || opt.action === 'instagram') {
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => { setCopied(false); if (opt.action === 'copy') onClose(); }, 2000);
        if (opt.action === 'instagram') {
          setTimeout(() => window.open('https://www.instagram.com/', '_blank'), 500);
        }
      } catch {
        // fallback
        const ta = document.createElement('textarea');
        ta.value = url; document.body.appendChild(ta); ta.select();
        document.execCommand('copy'); document.body.removeChild(ta);
        setCopied(true);
        setTimeout(() => { setCopied(false); onClose(); }, 2000);
      }
    } else if (opt.href) {
      window.open(opt.href, '_blank', 'noopener,width=600,height=500');
      onClose();
    }
  };

  return (
    <div ref={menuRef} style={{
      position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 600,
      background: '#fff', borderRadius: 14, boxShadow: '0 8px 32px rgba(0,0,0,0.14)',
      border: '1px solid #EAECEF', padding: '8px', width: 220,
      animation: 'fadeInDown .15s ease',
    }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '0.6px', padding: '4px 8px 8px' }}>
        Partager ce logement
      </div>
      {options.map((opt) => (
        <button
          key={opt.label}
          onClick={() => handleClick(opt)}
          style={{
            width: '100%', display: 'flex', alignItems: 'center', gap: 10,
            padding: '9px 10px', border: 'none', borderRadius: 9,
            background: 'transparent', cursor: 'pointer', fontFamily: 'var(--sans)',
            transition: 'background .12s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = opt.bg}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
        >
          <div style={{ width: 32, height: 32, borderRadius: 8, background: opt.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            {opt.icon}
          </div>
          <span style={{ fontSize: 13, fontWeight: 500, color: opt.color }}>{opt.label}</span>
        </button>
      ))}
      <style>{`@keyframes fadeInDown { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </div>
  );
}

export default function ListingPage({ listing, onNavigate }) {
  const isMobile = window.innerWidth < 768;
  const [realListing, setRealListing]   = useState(null);
  const [realReviews, setRealReviews]   = useState([]);
  const [hostProfile, setHostProfile]   = useState(null);
  const [loadingData, setLoadingData]   = useState(false);
  const [bookedRanges, setBookedRanges] = useState([]);
  const [nextAvailable, setNextAvailable] = useState(null);
  // ── Partage ──
  const [shareOpen, setShareOpen] = useState(false);
  const [faqOpen, setFaqOpen] = useState(false);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const shareRef = useRef(null);

  const rawListing = listing || {};

  // Charger les vraies données
  useEffect(() => {
    if (!rawListing.id) return;
    setLoadingData(true);
    Promise.all([
      supabase.from('listings').select('*').eq('id', rawListing.id).single(),
      supabase.from('reviews').select('*, guest:guest_id(full_name, email)').eq('listing_id', rawListing.id).eq('reviewer_type', 'voyageur').eq('visible', true).order('created_at', { ascending: false }),
      rawListing.host_id ? supabase.from('host_profiles').select('*').eq('id', rawListing.host_id).single() : Promise.resolve({ data: null }),
    ]).then(([{ data: lst }, { data: rvws }, { data: host }]) => {
      if (lst)      setRealListing(lst);
      if (rvws?.length) setRealReviews(rvws);
      if (host)     setHostProfile(host);
    }).finally(() => setLoadingData(false));
  }, [rawListing.id, rawListing.host_id]);

  // Charger les dates réservées
  useEffect(() => {
    const listingId = rawListing.id;
    if (!listingId) return;
    const today = new Date(); today.setHours(12, 0, 0, 0);
    const todayISO = today.toISOString().split('T')[0];
    supabase
      .from('bookings')
      .select('date_start, date_end')
      .eq('listing_id', listingId)
      .in('status', ['pending', 'confirmed', 'checkin'])
      .gte('date_end', todayISO)
      .then(({ data }) => {
        if (!data?.length) return;
        setBookedRanges(data);
        setNextAvailable(calcNextAvailable(data));
      });
  }, [rawListing.id]);

  const srcListing = realListing || rawListing;
  const l = {
  ...srcListing,
  title:         srcListing.title         || '',
  location:      srcListing.location      || srcListing.city || '',
  price:         srcListing.price         || srcListing.price_night || srcListing.priceNight || 0,
  rating:        srcListing.rating        || null,
  guests:        srcListing.guests        || srcListing.guests_max || 4,
  beds:          srcListing.beds          || srcListing.bedrooms   || 3,
  baths:         srcListing.baths         || srcListing.bathrooms  || 2,
  amenities:     srcListing.amenities     || [],
  adults_count:  srcListing.adults_count  || null,
  children_count: srcListing.children_count || null,
};

  // Construire l'URL de partage
  // /api/emma?listing=ID → les bots reçoivent les balises OG, les humains sont redirigés vers /?listing=ID
  const listingId = (realListing?.id || rawListing?.id);
  const shareUrl = typeof window !== 'undefined'
    ? (listingId
        ? `${window.location.origin}/api/emma?listing=${listingId}`
        : window.location.href)
    : '';

  const reviews = realReviews.length > 0 ? realReviews.map(r => ({
    id: r.id,
    name:     r.guest?.full_name || r.guest?.email?.split('@')[0] || 'Voyageur',
    initials: (r.guest?.full_name || 'V').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase(),
    color:    ['#E8F5F0', '#EEEDFE', '#FDF0E6'][r.id % 3] || '#E8F5F0',
    date:     new Date(r.created_at).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }),
    rating:   r.rating_overall,
    text:     r.comment,
    hostReply: r.host_reply || null,
  })) : [];

  const avgRating = reviews.length
    ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(2)
    : null;

  const transparencyScore = realListing
    ? (realListing.score_transparency || calcTransparencyScore(realListing))
    : 0;

  const hostLevel  = hostProfile?.level || 'havenly';
  const LEVEL_LABELS = { havenly: 'Hôte Havenly', confirme: 'Hôte Confirmé', excellence: 'Hôte Excellence' };
  const hostName   = hostProfile?.full_name || 'Hôte vérifié';
  const hostInitials = hostName.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();

  const scoreDetails = realListing ? [
    { label: 'Photos du logement',       score: (realListing.photos?.length >= 5) ? 25 : Math.round((realListing.photos?.length || 0) * 5), max: 25 },
    { label: 'Description complète',     score: (realListing.description?.length >= 100) ? 20 : Math.round((realListing.description?.length || 0) * 0.2), max: 20 },
    { label: 'Équipements listés',       score: (realListing.amenities?.length >= 5) ? 15 : Math.round((realListing.amenities?.length || 0) * 3), max: 15 },
    { label: 'N° enregistrement mairie', score: realListing.registration_number ? 20 : 0, max: 20 },
    { label: 'Règles de la maison',      score: (realListing.rules?.length >= 50) ? 10 : 0, max: 10 },
    { label: 'Caution activée',          score: (realListing.price_deposit > 0) ? 10 : 0, max: 10 },
  ] : [];

  const [selectedImg, setSelectedImg] = useState(0);
  const [guideOpen, setGuideOpen]     = useState(false);
  const [emmaOpen, setEmmaOpen]       = useState(false);
  const [isFav, setIsFav] = useState(() => {
    const favs = JSON.parse(localStorage.getItem('havenly_favorites') || '[]');
    return favs.includes(l.id);
  });

  const toggleFav = () => {
    const favs = JSON.parse(localStorage.getItem('havenly_favorites') || '[]');
    const newFavs = isFav ? favs.filter(f => f !== l.id) : [...favs, l.id];
    localStorage.setItem('havenly_favorites', JSON.stringify(newFavs));
    setIsFav(!isFav);
  };

  const [emmaMessages, setEmmaMessages] = useState([
    { from: 'emma', text: `Bonjour ! Je suis Emma, l'assistante pour ce logement à ${l.location} 😊 Des questions sur les équipements, la réservation ou les activités à proximité ?` }
  ]);
  const [emmaInput, setEmmaInput]   = useState('');
  const [emmaTyping, setEmmaTyping] = useState(false);
  const messagesEndRef = useRef(null);

  const todayStr = new Date().toISOString().split('T')[0];
  const defInD   = new Date(); defInD.setDate(defInD.getDate() + 7);
  const [dateIn,      setDateIn]      = useState(defInD.toISOString().split('T')[0]);
  const [guestsCount, setGuestsCount] = useState(2);
  const minNights = l.min_nights || 1;

  const getEffectiveMinNights = (dateStr) => {
    if (!l.custom_prices?.length) return minNights;
    const d = new Date(dateStr);
    const active = l.custom_prices.find(cp => {
      if (!cp.start || !cp.end) return false;
      return d >= new Date(cp.start) && d <= new Date(cp.end);
    });
    return active?.minNights || minNights;
  };

  const getEffectivePriceNight = (dateStr) => {
    if (!l.custom_prices?.length) return l.price || l.price_night || l.priceNight || 0;
    const d = new Date(dateStr);
    const active = l.custom_prices.find(cp => {
      if (!cp.start || !cp.end || !cp.price) return false;
      return d >= new Date(cp.start) && d <= new Date(cp.end);
    });
    return active ? Number(active.price) : (l.price || l.price_night || l.priceNight || 0);
  };

  const effectiveMinNights = getEffectiveMinNights(dateIn);
  const minDateOut = (() => { const d = new Date(defInD); d.setDate(d.getDate() + effectiveMinNights); return d.toISOString().split('T')[0]; })();
  const [dateOut, setDateOut] = useState(minDateOut);
  const nights     = Math.max(effectiveMinNights, Math.round((new Date(dateOut) - new Date(dateIn)) / 86400000));
  const priceNight  = getEffectivePriceNight(dateIn);
  const basePrice   = l.price || l.price_night || l.priceNight || 0;
  const cleaningFee = l.price_cleaning || 0;
  const havenlyFee  = Math.round(priceNight * nights * 0.08);
  const taxeSejour  = l.taxe_sejour ? Math.round(l.taxe_sejour * guestsCount * nights) : 0;
  const totalPrice = priceNight * nights + cleaningFee + taxeSejour;
  const handleDateIn = (v) => {
    const isBooked = bookedRanges.some(r => v >= r.date_start && v < r.date_end);
    if (isBooked) {
      const range = bookedRanges.find(r => v >= r.date_start && v < r.date_end);
      if (range) {
        const nextFree = new Date(range.date_end + 'T12:00:00');
        nextFree.setDate(nextFree.getDate() + 1);
        v = nextFree.toISOString().split('T')[0];
      }
    }
    setDateIn(v);
    const eff    = getEffectiveMinNights(v);
    const minOut = new Date(v);
    minOut.setDate(minOut.getDate() + eff);
    const minOutStr = minOut.toISOString().split('T')[0];
    if (dateOut < minOutStr) setDateOut(minOutStr);
  };

  const handleDateOut = (v) => {
    const eff    = getEffectiveMinNights(dateIn);
    const minOut = new Date(dateIn);
    minOut.setDate(minOut.getDate() + eff);
    const minOutStr = minOut.toISOString().split('T')[0];
    setDateOut(v < minOutStr ? minOutStr : v);
  };

  const goToBooking = () => onNavigate('booking', { ...l, price_night: priceNight, host: hostProfile, dateIn, dateOut, guests: guestsCount });

  useEffect(() => {
    if (messagesEndRef.current) messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [emmaMessages, emmaTyping]);

  const sendEmmaMessage = async (text) => {
    const msg = (text || emmaInput).trim();
    if (!msg) return;
    setEmmaMessages(prev => [...prev, { from: 'user', text: msg }]);
    setEmmaInput('');
    setEmmaTyping(true);
    try {
      const res = await fetch('/api/emma', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: msg,
          listing:  l,
          hostName: hostProfile?.full_name?.split(' ')[0] || "l'hôte",
          conversationHistory: emmaMessages.slice(-8).map(m => ({
            role:    m.from === 'user' ? 'user' : 'assistant',
            content: m.text,
          })),
        }),
      });
      const data = await res.json();
      setEmmaMessages(prev => [...prev, { from: 'emma', text: data.reply || getEmmaReply(msg, l) }]);
    } catch (e) {
      setEmmaMessages(prev => [...prev, { from: 'emma', text: getEmmaReply(msg, l) }]);
    } finally {
      setEmmaTyping(false);
    }
  };

  const mainPhoto = l.photos?.[0] || l.img || 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80';
  const videoUrl  = l.video_url || null;
  const PHOTOS    = l.photos?.length > 0
    ? l.photos.map((url, i) => ({ url, label: i === 0 ? 'Photo principale' : 'Photo ' + (i + 1) }))
    : [{ url: mainPhoto, label: 'Photo principale' }];
  const displayAmenities = l.amenities.map(a => ({ label: a, Icon: getAmenityIcon(a) }));
  const scoreColor = transparencyScore >= 80 ? '#0F6E56' : transparencyScore >= 50 ? '#534AB7' : '#C4784A';

  const dispoBanner = bookedRanges.length > 0 && nextAvailable ? (
    <div style={{ fontSize: 12, color: '#C4784A', background: '#FDF0E6', padding: '8px 14px', borderTop: '0.5px solid var(--border)', display: 'flex', alignItems: 'center', gap: 6 }}>
      <span>⚠</span>
      <span>Certaines dates sont réservées — prochaine disponibilité : <strong>{nextAvailable.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</strong></span>
    </div>
  ) : null;

  const dateBlock = (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: '1px solid var(--border)' }}>
        <div style={{ padding: '10px 14px', borderRight: '1px solid var(--border)' }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4 }}>Arrivée</div>
          <input type="date" value={dateIn} min={todayStr} onChange={e => handleDateIn(e.target.value)}
            style={{ fontSize: 13, fontWeight: 500, border: 'none', outline: 'none', background: 'transparent', fontFamily: 'var(--sans)', cursor: 'pointer', width: '100%', color: 'var(--ink)' }} />
        </div>
        <div style={{ padding: '10px 14px' }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4 }}>Départ</div>
          <input type="date" value={dateOut}
            min={(() => { const d = new Date(dateIn); d.setDate(d.getDate() + effectiveMinNights); return d.toISOString().split('T')[0]; })()}
            onChange={e => handleDateOut(e.target.value)}
            style={{ fontSize: 13, fontWeight: 500, border: 'none', outline: 'none', background: 'transparent', fontFamily: 'var(--sans)', cursor: 'pointer', width: '100%', color: 'var(--ink)' }} />
        </div>
      </div>
      <div style={{ padding: '8px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: 10, fontWeight: 600, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4 }}>Voyageurs</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button onClick={() => setGuestsCount(g => Math.max(1, g-1))} style={{ width: 24, height: 24, borderRadius: '50%', border: '1px solid var(--border)', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>−</button>
            <span style={{ fontSize: 14, fontWeight: 500 }}>{guestsCount}</span>
            <button onClick={() => setGuestsCount(g => Math.min(l.guests || l.guests_max || 10, g+1))} style={{ width: 24, height: 24, borderRadius: '50%', border: '1px solid var(--border)', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>+</button>
          </div>
        </div>
        <span style={{ fontSize: 12, color: 'var(--green-mid)', background: 'var(--green-light)', padding: '3px 10px', borderRadius: 20, fontWeight: 500 }}>
          {nights} nuit{nights > 1 ? 's' : ''}{minNights > 1 ? ` · min. ${effectiveMinNights}` : ''}
        </span>
      </div>
      {dispoBanner}
    </>
  );

  return (
    <div style={{ background: 'var(--white)', minHeight: '100vh', paddingTop: 60 }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: isMobile ? '1rem' : '2rem' }}>

        {/* Titre + actions */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <button onClick={() => onNavigate('home')} style={{ background: 'none', border: 'none', fontSize: 13, color: 'var(--ink-3)', cursor: 'pointer', padding: 0 }}>← Retour au site</button>

            <div style={{ display: 'flex', gap: 8 }}>
              {/* ── BOUTON PARTAGER avec menu dropdown ── */}
              <div ref={shareRef} style={{ position: 'relative' }}>
                <button
                  onClick={() => setShareOpen(o => !o)}
                  style={{ display: 'flex', alignItems: 'center', gap: 6, background: shareOpen ? 'var(--surface)' : 'none', border: shareOpen ? '1px solid var(--border)' : 'none', fontSize: 13, color: 'var(--ink)', cursor: 'pointer', padding: '6px 12px', borderRadius: 8, transition: 'all .15s' }}
                  onMouseEnter={e => { if (!shareOpen) e.currentTarget.style.background = 'var(--surface)'; }}
                  onMouseLeave={e => { if (!shareOpen) e.currentTarget.style.background = 'none'; }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
                  </svg>
                  Partager
                </button>
                {shareOpen && (
                  <ShareMenu
                    title={l.title}
                    url={shareUrl}
                    onClose={() => setShareOpen(false)}
                  />
                )}
              </div>

              {/* ── BOUTON FAVORI (inchangé) ── */}
              <button
                onClick={toggleFav}
                style={{ display: 'flex', alignItems: 'center', gap: 6, background: isFav ? 'var(--green-light)' : 'none', border: 'none', fontSize: 13, color: isFav ? 'var(--green-mid)' : 'var(--ink)', cursor: 'pointer', padding: '6px 12px', borderRadius: 8 }}
                onMouseEnter={e => e.currentTarget.style.background = 'var(--surface)'}
                onMouseLeave={e => e.currentTarget.style.background = isFav ? 'var(--green-light)' : 'none'}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill={isFav ? 'var(--green-mid)' : 'none'} stroke={isFav ? 'var(--green-mid)' : 'currentColor'} strokeWidth="2">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                </svg>
                {isFav ? 'Enregistré' : 'Enregistrer'}
              </button>
            </div>
          </div>

          <h1 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(20px, 3vw, 32px)', letterSpacing: '-0.5px', marginBottom: 8 }}>{l.title}</h1>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 14, color: 'var(--ink-3)', flexWrap: 'wrap' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <span style={{ color: '#BA7517' }}>★</span>
              <strong style={{ color: 'var(--ink)' }}>{avgRating}</strong>
              <span>· {reviews.length} avis vérifiés</span>
            </span>
            <span>·</span>
            <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>
              {l.location}{realListing?.region && realListing.region !== l.location ? `, ${realListing.region}` : ''}
            </span>
            <span style={{ background: 'var(--terra-light)', color: 'var(--terra-mid)', fontSize: 11, fontWeight: 500, padding: '3px 10px', borderRadius: 20 }}>
              {LEVEL_LABELS[hostLevel] || 'Hôte vérifié Havenly'}
            </span>
            <span style={{ background: transparencyScore >= 80 ? '#E8F5F0' : '#EEEDFE', color: scoreColor, fontSize: 11, fontWeight: 500, padding: '3px 10px', borderRadius: 20, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              Transparence {transparencyScore}/100
            </span>
          </div>
        </div>

        {/* Galerie + Vidéo */}
<div style={{ display: 'flex', gap: 8, marginBottom: 32, height: isMobile ? 'auto' : 440 }}>
  
  {/* Carrousel */}
  <div style={{ position: 'relative', borderRadius: 16, overflow: 'hidden', flex: videoUrl && !isMobile ? '2' : '1', height: isMobile ? 260 : '100%' }}>
    <img src={PHOTOS[selectedImg].url} alt={PHOTOS[selectedImg].label}
      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'opacity 0.3s' }} />
    <div style={{ position: 'absolute', bottom: 14, right: 14, background: 'rgba(0,0,0,0.55)', color: '#fff', fontSize: 12, fontWeight: 500, padding: '4px 12px', borderRadius: 20 }}>
      {selectedImg + 1} / {PHOTOS.length}
    </div>
    {selectedImg > 0 && (
      <button onClick={() => setSelectedImg(i => i - 1)}
        style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.9)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--ink)" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
    )}
    {selectedImg < PHOTOS.length - 1 && (
      <button onClick={() => setSelectedImg(i => i + 1)}
        style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.9)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--ink)" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    )}
    {PHOTOS.length > 1 && (
      <div style={{ position: 'absolute', bottom: 14, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 6 }}>
        {PHOTOS.map((_, i) => (
          <div key={i} onClick={() => setSelectedImg(i)}
            style={{ width: i === selectedImg ? 20 : 6, height: 6, borderRadius: 3, background: i === selectedImg ? '#fff' : 'rgba(255,255,255,0.5)', cursor: 'pointer', transition: 'all 0.2s' }} />
        ))}
      </div>
    )}
  </div>

  {/* Vidéo à droite — desktop uniquement */}
  {videoUrl && !isMobile && (
    <div onClick={() => setVideoModalOpen(true)}
      style={{ position: 'relative', flex: '1', borderRadius: 16, overflow: 'hidden', cursor: 'pointer', background: '#000' }}>
      <video src={videoUrl} style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.75 }} muted />
      <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
        <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(255,255,255,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.3)' }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="var(--ink)" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg>
        </div>
        <span style={{ color: '#fff', fontSize: 12, fontWeight: 500, background: 'rgba(0,0,0,0.5)', padding: '3px 10px', borderRadius: 20 }}>Visite vidéo</span>
      </div>
      <div style={{ position: 'absolute', top: 10, right: 10, background: 'var(--green-light)', color: 'var(--green-mid)', fontSize: 11, fontWeight: 500, padding: '3px 10px', borderRadius: 20 }}>
        Exclusif Havenly
      </div>
    </div>
  )}
</div>

{/* Modale vidéo */}
{videoModalOpen && (
  <div onClick={() => setVideoModalOpen(false)}
    style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.92)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
    <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 800, position: 'relative' }}>
      <button onClick={() => setVideoModalOpen(false)}
        style={{ position: 'absolute', top: -44, right: 0, background: 'none', border: 'none', color: '#fff', fontSize: 28, cursor: 'pointer', lineHeight: 1 }}>×</button>
      <video src={videoUrl} controls autoPlay style={{ width: '100%', borderRadius: 12, maxHeight: isMobile ? '70vh' : '80vh' }} />
    </div>
  </div>
)}

{/* Vidéo mobile */}
{videoUrl && isMobile && (
  <div onClick={() => setVideoModalOpen(true)}
    style={{ position: 'relative', borderRadius: 16, overflow: 'hidden', cursor: 'pointer', height: 140, background: '#000', marginBottom: 24 }}>
    <video src={videoUrl} style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.75 }} muted />
    <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'rgba(255,255,255,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="var(--ink)" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg>
      </div>
    </div>
    <div style={{ position: 'absolute', top: 10, right: 10, background: 'var(--green-light)', color: 'var(--green-mid)', fontSize: 11, fontWeight: 500, padding: '3px 10px', borderRadius: 20 }}>Exclusif Havenly</div>
  </div>
)}

{/* Contenu principal */}
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 340px', gap: isMobile ? 24 : 48, alignItems: 'start' }}>
          <div>
            {/* Infos hôte */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 24, borderBottom: '1px solid var(--border)' }}>
              <div>
                <h2 style={{ fontSize: 18, fontWeight: 500, marginBottom: 4 }}>
  Logement complet · {l.adults_count || l.guests} adulte{(l.adults_count || l.guests) > 1 ? 's' : ''}
  {l.children_count > 0 ? ` · ${l.children_count} enfant${l.children_count > 1 ? 's' : ''}` : ''}
  {' · '}{l.beds} chambre{l.beds > 1 ? 's' : ''} · {l.baths} sdb
</h2>
                <div style={{ fontSize: 14, color: 'var(--ink-3)', display: 'flex', alignItems: 'center', gap: 8 }}>
                  Hôte : {hostName}
                  {hostProfile?.is_founder && <span style={{ background: 'var(--green-light)', color: 'var(--green-mid)', fontSize: 11, fontWeight: 500, padding: '2px 8px', borderRadius: 20 }}>Fondateur</span>}
                </div>
              </div>
              <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'var(--green-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, color: 'var(--green-mid)', fontSize: 15, flexShrink: 0 }}>{hostInitials}</div>
            </div>

            {/* Points forts */}
            <div style={{ padding: '24px 0', borderBottom: '1px solid var(--border)', display: 'flex', flexDirection: 'column', gap: 16 }}>
              {[
                { title: 'Prix final garanti',        desc: 'Le prix affiché inclut toutes les taxes. Aucun frais caché au moment de payer.' },
                { title: 'Politique d\'annulation', desc: "Remboursement intégral jusqu'à 14 jours avant votre arrivée. Entre 7 et 14 jours : 50% remboursé. Moins de 7 jours : aucun remboursement." },
                { title: LEVEL_LABELS[hostLevel] || 'Hôte vérifié Havenly', desc: "Les hôtes vérifiés ont une expérience confirmée et d'excellentes évaluations." },
              ].map(item => (
                <div key={item.title} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                  <div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--green)', flexShrink: 0, marginTop: 6 }} />
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 2 }}>{item.title}</div>
                    <div style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.6 }}>{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>

           

            {/* Description */}
            <div style={{ padding: '24px 0', borderBottom: '1px solid var(--border)' }}>
              <h3 style={{ fontSize: 16, fontWeight: 500, marginBottom: 12 }}>À propos de ce logement</h3>
              <p style={{ fontSize: 14, color: 'var(--ink-3)', lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                {l.description || (() => {
                  const type = getType(l.title);
                  if (type === 'mas')         return "Niché au cœur de la Provence, ce mas en pierre vous offre le calme et l'authenticité de la campagne provençale.";
                  if (type === 'appartement') return "Situé en plein cœur de la ville, cet appartement lumineux et élégamment décoré vous offre tout le confort d'un logement haut de gamme.";
                  if (type === 'chalet')      return 'Ce chalet chaleureux vous accueille dans un cadre montagnard exceptionnel.';
                  if (type === 'bergerie')    return "Cette bergerie authentique rénovée avec goût vous plonge dans l'âme de la Corse.";
                  return "Nichée dans un cadre exceptionnel, cette villa lumineuse vous offre tout le confort d'un séjour haut de gamme.";
                })()}
              </p>
              <p style={{ fontSize: 14, color: 'var(--ink-3)', lineHeight: 1.8, marginTop: 12 }}>
                Le logement dispose d'une cuisine entièrement équipée, d'un salon lumineux et de {l.beds} chambres confortables. {l.guests} voyageurs peuvent y séjourner dans un cadre idyllique.
              </p>

              {/* Règles du logement */}
              {l.rules && (
                <div style={{ marginTop: 20, background: 'var(--surface)', borderRadius: 12, padding: '16px 20px' }}>
                  <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--ink-3)" strokeWidth="1.8"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>
                    Règles du logement
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {/* Toggles fumeur/animaux/fêtes */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
                      {[
                        { key: 'smoking_allowed', label: 'Fumeur', yes: '✓ Autorisé', no: '✗ Non autorisé' },
                        { key: 'pets_allowed',    label: 'Animaux', yes: '✓ Acceptés', no: '✗ Non acceptés' },
                        { key: 'parties_allowed', label: 'Fêtes', yes: '✓ Autorisées', no: '✗ Non autorisées' },
                      ].map(r => (
                        <span key={r.key} style={{ fontSize: 12, padding: '4px 12px', borderRadius: 20, background: l[r.key] ? '#E8F5F0' : '#FCEBEB', color: l[r.key] ? '#0F6E56' : '#A32D2D', fontWeight: 500 }}>
                          {r.label} : {l[r.key] ? r.yes : r.no}
                        </span>
                      ))}
                    </div>
                    {/* Règles texte */}
                    {l.rules.split('\n\n').filter(Boolean)
                      .map(r => r.replace(/^#+\s*/gm, '').replace(/\*\*/g, '').replace(/^-\s*/gm, '').trim())
                      .filter(r => r.length > 2)
                      .map((rule, i) => (
                        <div key={i} style={{ display: 'flex', gap: 10, fontSize: 13, color: 'var(--ink-3)', alignItems: 'flex-start' }}>
                          <span style={{ color: 'var(--green-mid)', flexShrink: 0, marginTop: 2 }}>•</span>
                          <span style={{ lineHeight: 1.6 }}>{rule}</span>
                        </div>
                      ))
                    }
                    {/* Durée minimale */}
                    {l.min_nights > 1 && (
                      <div style={{ display: 'flex', gap: 10, fontSize: 13, color: 'var(--ink-3)', alignItems: 'center', marginTop: 4 }}>
                        <span style={{ color: 'var(--green-mid)', flexShrink: 0 }}>•</span>
                        <span>Séjour minimum : <strong>{l.min_nights} nuits</strong></span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Équipements */}
            <div style={{ padding: '24px 0', borderBottom: '1px solid var(--border)' }}>
              <h3 style={{ fontSize: 16, fontWeight: 500, marginBottom: 16 }}>Ce que propose ce logement</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                {displayAmenities.map(a => (
                  <div key={a.label} style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 14, color: 'var(--ink-3)' }}>
                    <span style={{ flexShrink: 0 }}><a.Icon /></span>
                    {a.label}
                  </div>
                ))}
              </div>
            </div>

            {/* Guide local */}
            <div style={{ padding: '24px 0', borderBottom: '1px solid var(--border)' }}>
              <div onClick={() => setGuideOpen(g => !g)}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', marginBottom: guideOpen ? 12 : 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <h3 style={{ fontSize: 16, fontWeight: 500 }}>Les bons plans de {hostName.split(' ')[0]}</h3>
                  <span style={{ background: 'var(--green-light)', color: 'var(--green-mid)', fontSize: 11, fontWeight: 500, padding: '3px 10px', borderRadius: 20 }}>Guide exclusif</span>
                </div>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--ink-3)" strokeWidth="2" style={{ transform: guideOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s', flexShrink: 0 }}>
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </div>
              {guideOpen && (() => {
                const guide = l.local_guide || l.localGuide || {};
                const GUIDE_SECTIONS = [
                  { key: 'restaurants', label: 'Restaurants & Cafés',    color: '#C4784A', bg: '#FDF0E6', emoji: '🍽' },
                  { key: 'plages',      label: 'Plages & Nature',         color: '#0F6E56', bg: '#E8F5F0', emoji: '🏖' },
                  { key: 'activites',   label: 'Activités & Visites',     color: '#534AB7', bg: '#EEEDFE', emoji: '🎯' },
                  { key: 'transports',  label: 'Transports & Bons plans', color: '#1A1A2E', bg: '#F3F4F6', emoji: '🚌' },
                ];
                const hasGuide = GUIDE_SECTIONS.some(s => guide[s.key]?.trim());
                if (!hasGuide) return <p style={{ fontSize: 13, color: 'var(--ink-3)', fontStyle: 'italic', marginTop: 8 }}>Aucun guide local disponible pour ce logement.</p>;
                return (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginTop: 12 }}>
                    {GUIDE_SECTIONS.filter(s => guide[s.key]?.trim()).map(section => {
                      const items = (guide[section.key] || '').split(/[.\n]+/).filter(i => i.trim().length > 2);
                      return (
                        <div key={section.key} style={{ background: section.bg, borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(0,0,0,0.06)' }}>
                          <div style={{ padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
                            <span style={{ fontSize: 16 }}>{section.emoji}</span>
                            <span style={{ fontSize: 13, fontWeight: 500, color: section.color }}>{section.label}</span>
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {items.map((item, i) => (
                              <div key={i} style={{ padding: '12px 14px', borderBottom: i < items.length - 1 ? '1px solid rgba(0,0,0,0.05)' : 'none', display: 'flex', gap: 10 }}>
                                <div style={{ width: 20, height: 20, borderRadius: '50%', background: 'rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 600, color: section.color, flexShrink: 0, marginTop: 1 }}>{i + 1}</div>
                                <div style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.55 }}>{item.trim()}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>

            {/* FAQ voyageurs */}
{l.faq?.length > 0 && (
  <div style={{ padding: '24px 0', borderBottom: '1px solid var(--border)' }}>
    <div onClick={() => setFaqOpen(f => !f)}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', marginBottom: faqOpen ? 16 : 0 }}>
      <h3 style={{ fontSize: 16, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 10 }}>
        Questions fréquentes
        <span style={{ background: '#EEEDFE', color: '#534AB7', fontSize: 11, fontWeight: 500, padding: '3px 10px', borderRadius: 20 }}>FAQ</span>
      </h3>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--ink-3)" strokeWidth="2" style={{ transform: faqOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s', flexShrink: 0 }}>
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </div>
    {faqOpen && (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {l.faq.map((f, i) => (
          <div key={i} style={{ background: 'var(--surface)', borderRadius: 10, padding: '14px 16px' }}>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 6 }}>
              <span style={{ color: '#534AB7', marginRight: 8 }}>Q.</span>{f.q}
            </div>
            <div style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.7 }}>
              <span style={{ color: 'var(--green-mid)', marginRight: 8, fontWeight: 500 }}>R.</span>{f.a}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
)}

            {/* Avis */}
            <div style={{ padding: '24px 0' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
                <div style={{ display: 'flex', gap: 2 }}>{[1,2,3,4,5].map(s => <span key={s} style={{ color: '#BA7517', fontSize: 20 }}>★</span>)}</div>
                <span style={{ fontSize: 22, fontWeight: 500 }}>{avgRating}</span>
                <span style={{ fontSize: 14, color: 'var(--ink-3)' }}>· {reviews.length} avis vérifiés</span>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 24 }}>
                {reviews.map(r => (
                  <div key={r.id} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div style={{ width: 38, height: 38, borderRadius: '50%', background: r.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', flexShrink: 0 }}>{r.initials}</div>
                      <div>
                        <div style={{ fontSize: 14, fontWeight: 500 }}>{r.name}</div>
                        <div style={{ fontSize: 12, color: 'var(--ink-3)' }}>{r.date}</div>
                      </div>
                      <div style={{ marginLeft: 'auto', display: 'flex', gap: 2 }}>
                        {[1,2,3,4,5].map(s => <span key={s} style={{ color: s <= r.rating ? '#BA7517' : '#E0E0E0', fontSize: 12 }}>★</span>)}
                      </div>
                    </div>
                    <p style={{ fontSize: 14, color: 'var(--ink-3)', lineHeight: 1.7, margin: 0 }}>{r.text}</p>
                    {r.hostReply && (
                      <div style={{ background: 'var(--surface)', borderRadius: 10, padding: '10px 14px', borderLeft: '3px solid var(--green)' }}>
                        <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 4, color: 'var(--green-mid)' }}>Réponse de l'hôte</div>
                        <p style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.6, margin: 0 }}>{r.hostReply}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Carte réservation DESKTOP */}
          {!isMobile && (
            <div style={{ position: 'sticky', top: 80 }}>
              <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 16, padding: '24px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 4 }}>
                  <span style={{ fontSize: 22, fontWeight: 500 }}>{priceNight} €</span>
                  <span style={{ fontSize: 14, color: 'var(--ink-3)' }}>/ nuit · prix final</span>
                  {priceNight !== basePrice && (
                    <span style={{ fontSize: 11, background: '#FAEEDA', color: '#854F0B', padding: '2px 8px', borderRadius: 20, fontWeight: 500 }}>Tarif spécial</span>
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, marginBottom: 16 }}>
                  <span style={{ color: '#BA7517' }}>★</span>
                  <strong>{avgRating}</strong>
                  <span style={{ color: 'var(--ink-3)' }}>· {reviews.length} avis</span>
                </div>
                <div style={{ border: '1px solid var(--border-2)', borderRadius: 10, overflow: 'hidden', marginBottom: 12 }}>
                  {dateBlock}
                </div>
                {realListing ? (
                  <button onClick={goToBooking}
                    style={{ width: '100%', padding: '13px', background: 'var(--green)', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)', marginBottom: 14 }}>
                    Réserver →
                  </button>
                ) : (
                  <>
                    <div style={{ background: '#FAEEDA', border: '1px solid #E8A87C', borderRadius: 10, padding: '12px 14px', marginBottom: 12 }}>
                      <div style={{ fontSize: 13, fontWeight: 500, color: '#854F0B', marginBottom: 4 }}>Ouverture aux voyageurs — été 2026</div>
                      <div style={{ fontSize: 12, color: '#C4784A', lineHeight: 1.6, marginBottom: 10 }}>Ce logement sera disponible à la réservation dès l'ouverture officielle de Havenly.</div>
                      <input type="email" placeholder="votre@email.com" style={{ width: '100%', padding: '8px 12px', border: '1px solid #E8A87C', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', marginBottom: 8, boxSizing: 'border-box', background: '#fff' }} />
                      <button style={{ width: '100%', padding: '10px', background: '#854F0B', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)' }}
                        onClick={e => { if (e.currentTarget.previousSibling.value) alert("Merci ! Vous serez notifié dès l'ouverture."); }}>Me notifier à l'ouverture →</button>
                    </div>
                    <p style={{ textAlign: 'center', fontSize: 12, color: 'var(--ink-4)', marginBottom: 12 }}>Ouverture prévue été 2026</p>
                  </>
                )}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
  {[
    { label: `${priceNight} € × ${nights} nuit${nights>1?'s':''}`, val: `${(priceNight*nights).toLocaleString('fr-FR')} €` },
    cleaningFee > 0 ? { label: 'Frais de ménage', val: `${cleaningFee} €` } : null,
    taxeSejour > 0 ? { label: 'Taxe de séjour', val: `${taxeSejour} €` } : null,
  ].filter(Boolean).map(row => (
    <div key={row.label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
      <span style={{ color: 'var(--ink-3)' }}>{row.label}</span><span>{row.val}</span>
    </div>
  ))}
                  {taxeSejour === 0 && <div style={{ fontSize: 11, color: 'var(--ink-4)' }}>Taxe de séjour collectée par l'hôte.</div>}
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 15, fontWeight: 600, borderTop: '1px solid var(--border)', paddingTop: 8, marginTop: 2 }}>
                    <span>Total</span><span>{totalPrice.toLocaleString('fr-FR')} €</span>
                  </div>
                  {(l.price_deposit || l.caution) > 0 && (
                    <div style={{ background: 'var(--surface)', borderRadius: 8, padding: '8px 10px', border: '1px solid var(--border)', marginTop: 4 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 2 }}>
                        <span style={{ fontWeight: 500 }}>🔒 Caution (dépôt de garantie)</span>
                        <span style={{ fontWeight: 500 }}>{l.price_deposit || l.caution} €</span>
                      </div>
                      <div style={{ fontSize: 11, color: 'var(--ink-4)' }}>Autorisation bancaire uniquement — aucun débit. Libérée automatiquement 48h après votre départ.</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Carte MOBILE */}
{isMobile && (
  <div style={{ marginTop: 24, background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 16, padding: '20px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
      <div>
        <span style={{ fontSize: 22, fontWeight: 500 }}>{priceNight} €</span>
        <span style={{ fontSize: 14, color: 'var(--ink-3)' }}> / nuit · prix final</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13 }}>
        <span style={{ color: '#BA7517' }}>★</span>
        <strong>{avgRating}</strong>
        <span style={{ color: 'var(--ink-3)' }}>· {reviews.length} avis</span>
      </div>
    </div>
    <div style={{ border: '1px solid var(--border)', borderRadius: 10, overflow: 'hidden', marginBottom: 12 }}>
      {dateBlock}
    </div>
    {realListing ? (
      <button onClick={goToBooking}
        style={{ width: '100%', padding: '12px', background: 'var(--green)', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)', marginBottom: 12 }}>
        Réserver →
      </button>
    ) : (
      <div style={{ background: '#FAEEDA', border: '1px solid #E8A87C', borderRadius: 10, padding: '12px 14px', marginBottom: 12 }}>
        <div style={{ fontSize: 13, fontWeight: 500, color: '#854F0B', marginBottom: 4 }}>Ouverture aux voyageurs — été 2026</div>
        <div style={{ fontSize: 12, color: '#C4784A', lineHeight: 1.6, marginBottom: 10 }}>Inscrivez-vous pour être notifié en avant-première.</div>
        <input type="email" placeholder="votre@email.com" style={{ width: '100%', padding: '8px 12px', border: '1px solid #E8A87C', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', marginBottom: 8, boxSizing: 'border-box', background: '#fff' }} />
        <button style={{ width: '100%', padding: '10px', background: '#854F0B', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)' }}
          onClick={e => { if (e.currentTarget.previousSibling.value) alert("Merci ! Vous serez notifié dès l'ouverture."); }}>Me notifier à l'ouverture →</button>
      </div>
    )}
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {[
        { label: `${priceNight} € × ${nights} nuit${nights > 1 ? 's' : ''}`, val: `${(priceNight * nights).toLocaleString('fr-FR')} €` },
        cleaningFee > 0 ? { label: 'Frais de ménage', val: `${cleaningFee} €` } : null,
        taxeSejour > 0 ? { label: 'Taxe de séjour', val: `${taxeSejour} €` } : null,
      ].filter(Boolean).map(row => (
        <div key={row.label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
          <span style={{ color: 'var(--ink-3)' }}>{row.label}</span><span>{row.val}</span>
        </div>
      ))}
      {taxeSejour === 0 && <div style={{ fontSize: 11, color: 'var(--ink-4)' }}>Taxe de séjour collectée par l'hôte.</div>}
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 15, fontWeight: 600, borderTop: '1px solid var(--border)', paddingTop: 8, marginTop: 2 }}>
        <span>Total</span><span>{totalPrice.toLocaleString('fr-FR')} €</span>
      </div>
      {(l.price_deposit || l.caution) > 0 && (
        <div style={{ background: 'var(--surface)', borderRadius: 8, padding: '8px 10px', border: '1px solid var(--border)', marginTop: 4 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 2 }}>
            <span style={{ fontWeight: 500 }}>🔒 Caution (dépôt de garantie)</span>
            <span style={{ fontWeight: 500 }}>{l.price_deposit || l.caution} €</span>
          </div>
          <div style={{ fontSize: 11, color: 'var(--ink-4)' }}>Autorisation bancaire uniquement — aucun débit. Libérée automatiquement 48h après votre départ.</div>
        </div>
      )}
    </div>
  </div>
)}
</div>

      {/* Emma flottante */}
      <div style={{ position: 'fixed', bottom: 16, right: 16, zIndex: 500 }}>
        {emmaOpen && (
          <div style={{ position: 'absolute', bottom: 70, right: 0, width: isMobile ? 'calc(100vw - 32px)' : 340, background: 'var(--white)', borderRadius: 16, boxShadow: '0 8px 40px rgba(0,0,0,0.15)', border: '1px solid var(--border)', overflow: 'hidden' }}>
            <div style={{ background: '#EEEDFE', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #AFA9EC' }}>
              <div>
                <div style={{ fontFamily: 'var(--serif)', fontSize: 16, color: '#3C3489' }}>Emma</div>
                <div style={{ fontSize: 11, color: '#534AB7', display: 'flex', alignItems: 'center', gap: 5, marginTop: 1 }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--green)', display: 'inline-block' }} />
                  En ligne · répond en 30s · FR / EN / ES / DE
                </div>
              </div>
              <button onClick={() => setEmmaOpen(false)} style={{ background: 'none', border: 'none', fontSize: 18, color: '#534AB7', cursor: 'pointer', lineHeight: 1 }}>×</button>
            </div>
            <div style={{ padding: 12, maxHeight: 260, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 10, background: 'var(--surface)' }}>
              {emmaMessages.map((emsg, i) => (
                <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: emsg.from === 'user' ? 'flex-end' : 'flex-start' }}>
                  {emsg.from === 'emma' && <div style={{ fontSize: 10, color: '#534AB7', marginBottom: 3, fontWeight: 500 }}>Emma</div>}
                  <div style={{ maxWidth: '85%', padding: '8px 12px', borderRadius: 12, fontSize: 13, lineHeight: 1.55, background: emsg.from === 'user' ? 'var(--ink)' : '#EEEDFE', color: emsg.from === 'user' ? '#fff' : 'var(--ink)', border: emsg.from === 'user' ? 'none' : '1px solid #AFA9EC', borderBottomRightRadius: emsg.from === 'user' ? 4 : 12, borderBottomLeftRadius: emsg.from === 'user' ? 12 : 4 }}>
                    {emsg.text}
                  </div>
                </div>
              ))}
              {emmaTyping && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: '#534AB7' }}>
                  <div style={{ display: 'flex', gap: 3 }}>{[0,1,2].map(i => <div key={i} style={{ width: 5, height: 5, borderRadius: '50%', background: '#534AB7', opacity: 0.6 }} />)}</div>
                  Emma rédige...
                </div>
              )}
              <div ref={messagesEndRef} />
            </div>
            {emmaMessages.length <= 1 && (
              <div style={{ padding: '8px 12px', borderTop: '1px solid var(--border)', display: 'flex', flexWrap: 'wrap', gap: 6, background: 'var(--white)' }}>
                {['Y a-t-il une piscine ?', 'Le parking est-il inclus ?', 'Y a-t-il le WiFi ?'].map((s, i) => (
                  <button key={i} onClick={() => sendEmmaMessage(s)} style={{ fontSize: 11, padding: '4px 10px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16, cursor: 'pointer', fontFamily: 'var(--sans)', color: 'var(--ink-3)', textAlign: 'left' }}>
                    {s}
                  </button>
                ))}
              </div>
            )}
            <div style={{ padding: '10px 12px', borderTop: '1px solid var(--border)', display: 'flex', gap: 8, background: 'var(--white)' }}>
              <input value={emmaInput} onChange={e => setEmmaInput(e.target.value)} onKeyDown={e => e.key === 'Enter' && sendEmmaMessage()}
                placeholder="Posez votre question..."
                style={{ flex: 1, padding: '7px 10px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none' }} />
              <button onClick={() => sendEmmaMessage()} style={{ padding: '7px 14px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)' }}>→</button>
            </div>
          </div>
        )}
        <button onClick={() => setEmmaOpen(!emmaOpen)} style={{ width: 56, height: 56, borderRadius: '50%', background: emmaOpen ? 'var(--ink)' : '#534AB7', border: 'none', cursor: 'pointer', boxShadow: '0 4px 20px rgba(83,74,183,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s' }}>
          {emmaOpen
            ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            : <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
          }
        </button>
        {!emmaOpen && (
          <div style={{ position: 'absolute', top: -4, right: -4, width: 18, height: 18, borderRadius: '50%', background: 'var(--green)', border: '2px solid var(--white)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 600, color: '#fff' }}>1</div>
        )}
      </div>
    </div>
  );
}
